class DateService {
    getTodayFormatedDate() {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    }

    normalize(d) {
        const date = new Date(d);
        date.setHours(0, 0, 0, 0);

        return date;
    }

    formatLocal(d) {
        return d.getFullYear() +
            '-' +
            String(d.getMonth() + 1).padStart(2, '0') +
            '-' +
            String(d.getDate()).padStart(2, '0');
    }

    formatDateForMeta(dateString, language = 'ru') {
        if (!dateString) return '';
        
        const today = this.getTodayFormatedDate();
        if (dateString === today) {
            return language === 'ru' ? 'сегодня' : 'today';
        }
        
        // Парсим дату в формате YYYY-MM-DD
        const [year, month, day] = dateString.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        
        const monthsRu = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 
                         'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
        const monthsGb = ['January', 'February', 'March', 'April', 'May', 'June',
                         'July', 'August', 'September', 'October', 'November', 'December'];
        
        const monthName = language === 'ru' ? monthsRu[date.getMonth()] : monthsGb[date.getMonth()];
        
        return language === 'ru' ? `${day} ${monthName} ${year}` : `${monthName} ${day}, ${year}`;
    }
}

const dateService = new DateService();
export default dateService;